import { createFileRoute } from "@tanstack/react-router"
import GhostTownTab from "~/components/product-management/tabs/GhostTownTab"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/product-management/_layout/ghost-variants")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Product Management - Ghost Variants")
  return <GhostTownTab />
}
